import {Box, styled, ContainedButton, Button, AutoAwesomeIcon, Typography} from '../../../ui-library';

export const ButtonsBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '30px 30px 24px 30px',
    width: '100%',
    [theme.breakpoints.down(1500)]: {
        flexDirection: 'column',
        gap: '11px'
    },
}));


export const CoupleBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    width: '100%',
    '&:first-of-type': {
        justifyContent: 'flex-start',
    },
    '&:last-of-type': {
        justifyContent: 'flex-end',
    },
    [theme.breakpoints.down(1500)]: {
        justifyContent: 'center',
    },
}));

export const ObjectsTitle = styled(Typography)`
    font-size: 20px;
    font-weight: 600;
    line-height: 27.24px;
    color:${({ theme }) => theme.palette.grey[600]};
`;

export const AddObjectBtn = styled(Button)`
    width: 50px;
    height: 41px;
    min-width: 0px;
    padding: 0px;
`;


export const RandomBtn = styled(Button)`
    font-size: 15px;
    line-height: 26px;
    border-radius: 7px;
    min-width: fit-content;
`;

export const StartBtn = styled(ContainedButton)`
    font-size: 15px;
    line-height: 26px;
    border-radius: 7px;
    min-width: fit-content;

`;
export const AddClassBtn = styled(Button)`
    font-size: 16px;
    line-height: 26px;
`;

export const AcIcon = styled(AutoAwesomeIcon)`
    font-size: 20px;
    margin-right: 7px;
    margin-left: -5px;
`;
